import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 자원 간트 차트 — AnalysisController#getActivities(resource-gantt).
// 응답은 List<ResourceGanttResultDto>(행=자원) 이고 각 행이 `activities[]`(ActivityDto)를 들고 있다.
// **행 내부 activities가 startTs 정렬이라는 보장이 없다**(ActivityQueryRepository의 orderBy가
// displaySeq → resourceCd → startTs) — 화면에서 행마다 startTs로 다시 정렬해야 히트테스트(이진탐색)가
// 맞는다. reports/gantt-implementation.md §5-2a F1.
const getActivities = (params) => fpApiUtil.postParams(`${ANALYSIS}/resource-gantt/activities`, params);

// 작업 순서 의존관계 — 응답은 `Map<woCd, "행,행,fromUniqueId,toUniqueId/…">`.
// 앞 2필드는 old TreeGrid의 행 인덱스(resourceCd 자연정렬 기준)이고 우리 행 순서와 어긋나므로
// **버리고 뒤 2필드(uniqueId)만** 쓴다. 백엔드가 이중 join이라 빈 세그먼트(`//`)가 섞일 수 있어
// `.filter(Boolean)`이 필수다(§5-4-(1)).
const getActivityRelations = (params) => fpApiUtil.postParams(`${ANALYSIS}/resource-gantt/activity-relations`, params);

// 바 hover/선택 시 상세 — old는 `$.ajax async:false`(동기 XHR)로 매번 UI를 멈췄지만 new는
// 디바운스 + 비동기 + 요청 토큰으로 바꾼다(fp-report-screen-guide.md §E-6).
const getActivityDetail = (params) => fpApiUtil.postParams(`${ANALYSIS}/resource-gantt/activity/detail`, params);

// 대체 자원(공정 기준) — 바를 선택하면 그 공정을 수행할 수 있는 자원 행을 좌측에서 강조한다.
// 응답은 `Map<routeCd, [{ resourceCd, … }]>`. AdjustmentController 소속이라 base가 다르다.
const getAltResources = (params) => fpApiUtil.postParams("factoryplan/adjustment/alt-resources", params);

// 하단 "생산 차질" 탭 — AnalysisController#getShortageActivities(resource-gantt/short-activities).
// **간트 본조회와 완전히 같은 params**를 쓴다(old loadData도 같은 postFormData를 그대로 넘겼다).
// 응답은 List<ShortageActivityDto>(주문 + 지연/결품 + 문제원인 23필드)이고 활동 단위가 아니라
// **조회 범위 전체의 차질 목록**이라 바 선택과 무관하다 — 그래서 조회 시 1회만 받아 둔다.
const getShortageActivities = (params) => fpApiUtil.postParams(`${ANALYSIS}/resource-gantt/short-activities`, params);

const fpResourceGanttService = {
  getActivities, getActivityRelations, getActivityDetail, getAltResources, getShortageActivities
};
export default fpResourceGanttService;
